import EditTrainingModal from './EditTrainingModal'
export default EditTrainingModal
